// Import the necessary Firebase modules
import { initializeApp } from "firebase/app";
import { getFirestore,collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { getFunctions } from 'firebase/functions';
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { ref, push } from "firebase/database";


const firebaseConfig = {
    apiKey: "AIzaSyAo8JAiRJUyz6ArJCHOCwEqHQEmfbWgtgA",
    authDomain: "olewin-academy.firebaseapp.com",
    projectId: "olewin-academy",
    storageBucket: "olewin-academy.appspot.com",
    messagingSenderId: "622543323365",
    appId: "1:622543323365:web:9a3e28d5c63850d60e940c",
    measurementId: "G-09WHHRMJRC"
  };
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const db = getFirestore(app);
  const functions = getFunctions(app);
  const googleProvider = new GoogleAuthProvider();
export { auth, googleProvider, ref, query, where, getDocs, push, db, functions,collection, addDoc  };